module.exports = __webpack_public_path__ + "img/5877a3c.jpg";